import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

import { updateFilters } from '../search/actions';

const mapStateToProps = state => ({
  search: state.Search
});

class AmenitiesSelect extends Component {
  constructor(props) {
    super(props);

    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.getSelectedOptions = this.getSelectedOptions.bind(this);
    this.areAllOptionsSelected = this.areAllOptionsSelected.bind(this);
    this.getDropdownButtonLabel = this.getDropdownButtonLabel.bind(this);
    this.removeStarFromLabel = this.removeStarFromLabel.bind(this);
  }

  getDropdownButtonLabel = ({ placeholderButtonLabel, value }) => {

    if (!value || value.length === 0)
      return placeholderButtonLabel;

    if (this.areAllOptionsSelected())
      return 'All';

    return `${value.length} selected`;
  }

  onSelectionChange = (selections, event) => {
    const { dispatch, amenities } = this.props;
    const { filters } = this.props.search;

    let types = []

    if (event.action === "select-option" && event.option.value ===
      "*") {
      types = amenities;
    } else if (event.action === "deselect-option" &&
      event.option.value === "*") {
      types = [];
    } else if (event.action === "deselect-option") {
      types = selections.filter(o => o.value !== "*");
      types = types.map(selection => selection.value);
    } else {
      types = selections.map(selection => selection.value);
    }

    const newFilters = { ...filters, amenities: types };
    dispatch(updateFilters(newFilters));
  }

  areAllOptionsSelected = () => {
    const { amenities, selectedValues } = this.props;

    if (!selectedValues || selectedValues.length === 0)
      return false;

    for (let i = 0; i < amenities.length; ++i) {
      if (!selectedValues.includes(amenities[i]))
        return false;
    }

    return true;
  }

  removeStarFromLabel = type => {
    return type.replace('*', '');
  }

  getSelectedOptions = () => {
    const { selectedValues } = this.props;

    return selectedValues.map(type => {
      return {
        label: this.removeStarFromLabel(type),
        value: type
      }
    });
  }

  render() {
    const { amenities, onFocus } = this.props;

    return (
      <div>
        <ReactMultiSelectCheckboxes
          options={amenities.map(type => {
            return {
              label: this.removeStarFromLabel(type),
              value: type
            };
          })}
          getDropdownButtonLabel={this.getDropdownButtonLabel}
          value={this.getSelectedOptions()}
          onFocus={onFocus}
          onChange={this.onSelectionChange}
          placeholderButtonLabel="Amenities"
        />
      </div>
    )
  }
}

export default connect(mapStateToProps)(AmenitiesSelect);
